
import { getProvince, getCity, getCounty } from '@/api/sys.js'
import PopupPicker from 'vux/src/components/popup-picker/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import Search from 'vux/src/components/search/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import debounce from 'vux/src/tools/debounce/index.js'
import Icon from 'vux/src/components/icon/index.vue'
import Selector from 'vux/src/components/selector/index.vue'

import { getUserList, assign, isWorker, getAreaType } from '@/api/zhigongxiaojia'
import addressPicker from './address.vue'
export default {
directives: {
TransferDom
},
components: {
XInput,
Group,
PopupPicker,
Popup,
Search,
Icon,
Selector,
addressPicker
},
data () {
return {
judge1: false,
judge2: false,
judge3: false,
judge4: false,
show_clear: false,
popupunit: false,
searchVal: '',
provinceid: '', // 省 id
cityid: '', // 地市 id
countyid: '', // 区县 id
choose_auth: '',
auth: [],
auth_name: [],
sourcetype: 1, // 1|职工小家
parentaccountid: '',
username: '',
page: 1,
rows: 15,
level: '',
userlist: [],
show_auth: false,
areatypeList: [],
addressValue: []
}
},
watch: {
searchVal () {
this.getUserListNow()
},
username () {
this.getinput()
}
},
computed: {
accountid () {
return this.$store.state.user.accountid
},
userid () {
return this.$store.state.user.userid
}
},
created () {
this.isWorkerNow()
},
methods: {
isWorkerNow () {
isWorker({
accountid: this.accountid,
sourcetype: this.sourcetype
}).then(data => {
this.level = data.returnValue.areatype
this.getAreaType()
this.provinceid = data.returnValue.provinceid
this.cityid = data.returnValue.cityid
this.countyid = data.returnValue.countyid
this.choose_auth = data.returnValue.auth
this.judge_auth()
})
},

create () {
this.provinceid = this.addressValue[0] || ''
this.cityid = this.addressValue[1] || ''
this.countyid = this.addressValue[2] || ''
if (this.username == '') {
this.$vux.toast.text('请输入姓名')
return false
}
if (this.level === '1' && this.provinceid === '') {
this.$vux.toast.text('请先选择所在地区')
return false
} else if ((this.level === '3' || this.level === '4') && this.cityid === '') {
this.$vux.toast.text('请先选择所在地区')
return false
} else if (this.level === '5' && this.countyid === '') {
this.$vux.toast.text('请先选择所在地区')
return false
}
if (this.auth == '') {
this.$vux.toast.text('请选择人员的权限配置')
return false
} else {
this.submit()
}
},

submit () {
assign({
accountid: parseInt(this.parentaccountid),
sourcetype: parseInt(this.sourcetype),
parentaccountid: this.accountid,
areatype: parseInt(this.level),
provinceid: parseInt(this.provinceid),
cityid: parseInt(this.cityid),
countyid: parseInt(this.countyid),
auth: this.auth.toString()
}).then(data => {
if (data.status == 'error') {



} else if (data.status == 'suc') {
window.history.back(-1)
}
}).catch(() => { })
},

getUserListNow: debounce(function () {
if (this.searchVal) {
getUserList({
name: this.searchVal,
page: this.page,
rows: this.rows
}).then(data => {
if (data.returnValue == '') {
this.userlist = []
document.querySelector('#nodata').innerHTML = '暂无查询结果'
} else if (data.returnValue != '') {
this.userlist = data.returnValue
document.querySelector('#nodata').innerHTML = ''
}
})
} else {
this.userlist = []
document.querySelector('#nodata').innerHTML = ''
}
}, 500),

getAreaType () {
let areatype = this.level
getAreaType().then(res => {
this.areatypeList = res.obj.filter(item => {
if (areatype === '4') {

return item.key === '4'
} else if (areatype === '5') {

return item.key === '5'
} else if (parseInt(item.key) >= parseInt(areatype)) {
return parseInt(item.key) >= parseInt(areatype)
}
})
})
},


chooselist (item) {
this.username = item.name
this.popupunit = false
this.parentaccountid = item.accountid
},

get_auth () {
this.show_auth = true
},

confirm () {
this.show_auth = false
this.auth.sort()
var i
for (i in this.auth) {
if (this.auth[i] == 1) { this.auth_name.push('指派') }
if (this.auth[i] == 2) { this.auth_name.push('申报') }
if (this.auth[i] == 3) { this.auth_name.push('审核') }
if (this.auth[i] == 4) { this.auth_name.push('发布') }
}
var testdiv = document.getElementById('select_auth')
testdiv.innerHTML = this.auth_name.join(' ')
this.auth_name.length = 0
},

cancel () {
this.show_auth = false
},

showUnit () {
this.popupunit = true
this.$nextTick(() => {
this.$refs.search.setFocus()
document.activeElement.scrollIntoViewIfNeeded(true)
})
},
getinput () {
if (this.username != '') {
this.show_clear = true
} else {
this.show_clear = false
}
},
clean_name () {
this.username = ''
},
judge_auth () {
if (this.choose_auth.indexOf(1) > -1) {
this.judge1 = true
}
if (this.choose_auth.indexOf(2) > -1) {
this.judge2 = true
}
if (this.choose_auth.indexOf(3) > -1) {
this.judge3 = true
}
if (this.choose_auth.indexOf(4) > -1 && this.level === '1') { // 只有省级可发布
this.judge4 = true
}
}
}
}
